export default "/images/5ecdca36a7a0a59cf28fcc1f5b549069.jpg";